import { render, staticRenderFns } from "./rpPeresentPersonel.vue?vue&type=template&id=0b4ba7fa&"
import script from "./rpPeresentPersonel.vue?vue&type=script&lang=js&"
export * from "./rpPeresentPersonel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
import { VToolbarTitle } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VSpacer,VToolbar,VToolbarTitle})
